import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { Expense } from '@webapp/modules/expense/entities/Expense'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

export const useQueryExpenseDetail = (uuid: string) => {
  const config = expenseReportQueryConfig.detail(uuid)

  const { data } = useQuery({
    queryKey: config.queryKey,
    queryFn: config.queryFn,
  })

  const expense = useMemo(
    () => (data ? new Expense(data) : undefined),
    [data]
  )

  return { expense }
}
